import  _ from 'lodash';
import { takeLatest, call, put } from 'redux-saga/effects';
import { fetchRecipientsByProject } from '../../../services/projects';
import * as actions from '../projectActions';

export default function* fetchRecipientByProjectWatcher() {
  yield takeLatest(actions.FETCH_RECIPIENTS, fetchRecipientByProjectWorker);
}
export function* fetchRecipientByProjectWorker(action) {
  try {
    const response = yield call(fetchRecipientsByProject, {
      closing_id: parseInt(action.closing_id),
    });
    yield call(success, response);
  } catch (error) {
    yield call(failure, error);
  }
}

export function* success(response) {
  yield put(actions.setRecipients(_.get(response, 'data.fetchRecipientsByProject', [])));
}

export function* failure(error) {
  yield put(actions.statusError(error));
}
